import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlogsComponent } from './blogs.component';
import { ViewAllBlogsComponent } from './view-all-blogs/view-all-blogs.component';


const routes: Routes = [
  { path: '', 
    component: BlogsComponent,
   },
    

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogsRoutingModule { }
